import Registry from './Registry';

class Filter
{
    instance(selector) {
        var inst = Registry.get(selector, 'Filter');
        if (inst)
            return inst;

        return new Filter(selector, false);
    }

    constructor(selector, checkReg) {
        if (checkReg !== false)
            return this.instance(selector);

        this.selector = selector;
        this.$ = $(selector);
        this.data = {};
        this.onChanges = {};

        this.collectData();
        this.listen();

        Registry.set(selector, this, 'Filter');
    }

    collectData() {
        var self = this;

        this.$.find('[name]').each(function() {
            var name = $(this).attr('name');
            if (name.substr(name.length - 2) === '[]')
                name = name.substr(0, name.length - 2);

            self.onChanges[name] = [];
            self.data[name] = $(this).val();
        });
    }

    onChange(names, func) {
        if (typeof names == 'string' && names !== '') {
            if (names.substr(0, 1) === '!')
                names = ['!', names.substr(1)];
            else
                names = [names];
        }

        if (typeof names != 'object')
            return console.error('Argument 1 in Filter.onChange must be an array. Type of ' + (typeof name) + ' given.');
        if (typeof func != 'function')
            return console.error('Argument 2 in Filter.onChange must be a function. Type of ' + (typeof func) + ' given.');

        if (names.length === 0)
            names = Object.keys(this.data);

        var ignore = names[0] === '!';
        if (ignore)
            names = names.slice(1);

        for (var name in this.onChanges) {
            if (ignore && names.indexOf(name) === -1)
                this.onChanges[name].push(func);
            if (! ignore && names.indexOf(name) > -1)
                this.onChanges[name].push(func);
        }

        return this;
    }

    listen() {
        var self = this;
        this.$.find('[name]').change(function(e) {
            var name = $(this).attr('name');
            var value = $(this).val();

            if (name.substr(name.length - 2) === '[]')
                name = name.substr(0, name.length - 2);

            self.data[name] = value;

            self.onChanges[name].forEach(function(func) {
                func(value, name, self.data, e);
            });
        });
    }
}

export default Filter;